module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "component-driver-reservation-request"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.$is('listing')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('ChargingSessionButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CS" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Port " + _vm._s(_vm.item.port))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("UUID")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.uuid))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("End")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.status))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Reservation")]), _c('div', [_c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.reservation_id
        }
      }
    }
  }, [_c('span', [_vm._v("R" + _vm._s(_vm.item.reservation_id))])])], 1)])])]) : _vm._e(), (_vm.$is('reservation')) ? _c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('ChargingSessionButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("CS" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "value"
  }, [_vm._v("Port " + _vm._s(_vm.item.port))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("UUID")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.uuid))])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.start))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("End")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.end))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.status))])])])]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fa0da84!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/ChargingSession.vue
// module id = 2325
// module chunks = 1